import * as actionTypes from "./actionTypes";

const initialState = {
  error: null,
  loading: false,
  isUpdating: false,
  paymentFormDetails: null
};

const fetchFormDetailsStart = (state) => ({
  ...state,
  loading: true,
  paymentFormDetails: {}
});

const resetForm = (state) => ({
  ...state,
  paymentFormDetails: null
});

const fetchFormDetailsSuccess = (state, action) => {
  const { paymentTrackerDto } = action.data;

  return {
    ...state,
    loading: false,
    paymentFormDetails: paymentTrackerDto
  };
};

const fetchFormDetailsFail = (state) => ({
  ...state,
  loading: false,
  paymentFormDetails: null
});

const updateFormDetailsStart = (state) => ({
  ...state,
  isUpdating: true,
  loading: false
});

const updateFormDetailsSuccess = (state, action) => ({
  ...state,
  isUpdating: false,
  loading: false,
  paymentFormDetails: action.data?.paymentTrackerDto
});

const updateFormDetailsFail = (state) => ({
  ...state,
  isUpdating: false,
  loading: false
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FORM_START:
      return fetchFormDetailsStart(state, action);
    case actionTypes.RESET_FORM:
      return resetForm(state, action);
    case actionTypes.FETCH_FORM_SUCCESS:
      return fetchFormDetailsSuccess(state, action);
    case actionTypes.FETCH_FORM_FAIL:
      return fetchFormDetailsFail(state, action);
    case actionTypes.UPDATE_FORM_START:
      return updateFormDetailsStart(state, action);
    case actionTypes.UPDATE_FORM_SUCCESS:
      return updateFormDetailsSuccess(state, action);
    case actionTypes.UPDATE_FORM_FAIL:
      return updateFormDetailsFail(state, action);
    default:
      return state;
  }
};

export default reducer;
